// native
import { BrowserModule, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { HammerGestureConfig } from '@angular/platform-browser';
import { ErrorHandler, Injectable, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';

// addon
import { ToastrModule } from 'ngx-toastr';
import { Router } from "@angular/router";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// components
import { AppComponent } from './app.component';

// service
import { AuthService } from './core/services/auth.service';
import { AppHttpInterceptor } from './app-http-interceptor.service';

// modules
import { SharedModule } from './shared/shared.module';
import { AboutModule } from './about/about.module';
import { NotFoundModule } from './notfound/notfound.module';
import { HelpModule } from './help/help.module';
import { DemoModule } from './demo/demo.module';
import { UsersModule } from './users/users.module';
import { OfficesModule } from './offices/offices.module';
import { DevicesModule } from './devices/devices.module';
import { PatientsModule } from './patients/patients.module';
import { TestsModule } from './tests/tests.module';
import { BundlesModule } from './bundles/bundles.module';
import { MonitorModule } from './monitor/monitor.module';
import { SettingsModule } from './settings/settings.module';
import { AuthModule } from './auth/auth.module';
import { AppRoutingModule } from './app-routing.module';
import { TechallModule } from './techall/techall.module';
import { CustomBundlesModule } from './custom-bundles/custom-bundles.module';
import { CoreModule } from './core/core.module';
import { ImportModule } from './import/import.module';
import { SupportModule } from './support/support.module';
import { WorkItemsModule } from './work-items/work-items.module';
import { InvitationsModule } from './invitations/invitations.module';
import { UnityModule } from './unity/unity.module';
import { ExportTasksModule } from './export-tasks/export-tasks.module';
import { DevSettingsModule } from './dev-settings/dev-settings.module';
import { HomeManagementModule } from './home-management/home-management.module';

export function createTranslateLoader(http: HttpClient) {
  // c=2: BAA v2 locale changes — a cached v1 dictionary lacks the new baa.* keys
  return new TranslateHttpLoader(http, './assets/locales/', '.json?c=2');
}

@Injectable()
class HammerConfig extends HammerGestureConfig {
  overrides = {
    pan: {
      direction: 6,
    },
    pinch: {
      enable: false,
    },
    rotate: {
      enable: false,
    },
  };
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            preventDuplicates: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en-us'
        }),
        HammerModule,
        AboutModule,
        AuthModule,
        CoreModule,
        HelpModule,
        DemoModule,
        NotFoundModule,
        UnityModule,
        DevicesModule,
        PatientsModule,
        CustomBundlesModule,
        OfficesModule,
        UsersModule,
        TestsModule,
        BundlesModule,
        MonitorModule,
        SettingsModule,
        SharedModule,
        TechallModule,
        ImportModule,
        SupportModule,
        WorkItemsModule,
        InvitationsModule,
        ExportTasksModule,
        DevSettingsModule,
        HomeManagementModule,
        AppRoutingModule], providers: [
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerConfig,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppHttpInterceptor,
            deps: [AuthService],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
            cookieName: 'csrftoken',
            headerName: 'X-CSRFToken',
        })),
    ] })
export class AppModule {
  constructor() { }
}
